'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState } from 'react';
import { extractTokenAtCursor, insertTokenIntoText } from '@edusense/entities-social';
import { useGetUsers, useGetHashtags } from '@edusense/tweet-client';
import { getSuggestions } from './useTokenAutocomplete.searchHandlers';
import { calculateCursorPosition } from './useTokenAutocomplete.utils';
export function useTokenAutocomplete(param) {
    var inputRef = param.inputRef, text = param.text, setText = param.setText, setProjectPreviews = param.setProjectPreviews;
    // 자동완성 관련 상태
    var _useState = _sliced_to_array(useState(null), 2), currentToken = _useState[0], setCurrentToken = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), suggestions = _useState1[0], setSuggestions = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isSearching = _useState2[0], setIsSearching = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), suggestionsPosition = _useState3[0], setSuggestionsPosition = _useState3[1];
    var _useState4 = _sliced_to_array(useState(''), 2), userQuery = _useState4[0], setUserQuery = _useState4[1];
    var _useState5 = _sliced_to_array(useState(''), 2), hashtagQuery = _useState5[0], setHashtagQuery = _useState5[1];
    // tweet-client에서 생성된 query hooks 사용
    var usersQuery = useGetUsers({
        query: userQuery
    }, {
        query: {
            enabled: userQuery.length >= 2,
            staleTime: 30 * 1000
        }
    });
    var hashtagsQuery = useGetHashtags({
        query: hashtagQuery
    }, {
        query: {
            enabled: hashtagQuery.length >= 2,
            staleTime: 30 * 1000
        }
    });
    // React Query 로딩 상태 반영
    var queryIsLoading = usersQuery.isLoading || hashtagsQuery.isLoading;
    // 텍스트 변경 처리
    var handleTextChange = function(e) {
        var newText = e.target.value;
        setText(newText);
        // 현재 입력 위치 가져오기
        var cursorPosition = e.target.selectionStart;
        var lastChar = newText.charAt(cursorPosition - 1);
        // 새로 입력된 문자가 특수문자(@, #, $)인지 확인
        var isSpecialChar = lastChar === '@' || lastChar === '#' || lastChar === '$';
        // 토큰 감지 및 자동완성 드롭다운 표시
        if (isSpecialChar) {
            console.log('특수문자 감지:', lastChar, '위치:', cursorPosition);
            setTimeout(detectTokenAndShowSuggestions, 0);
        } else {
            // 토큰 내에서 타이핑 중인지 확인
            var token = extractTokenAtCursor(newText, cursorPosition);
            if (token) {
                console.log('토큰 감지:', token);
                setTimeout(detectTokenAndShowSuggestions, 0);
            }
        }
    };
    // 토큰 감지 및 자동완성 드롭다운 표시
    var detectTokenAndShowSuggestions = function() {
        if (!inputRef.current) return;
        var currentPosition = inputRef.current.selectionStart;
        var token = extractTokenAtCursor(text, currentPosition);
        console.log('토큰 감지 결과:', token);
        if (token) {
            setCurrentToken(token);
            handleTokenDetection(token);
            // 토큰 위치 기준으로 드롭다운 표시 위치 계산
            var position = calculateCursorPosition(inputRef, token);
            console.log('드롭다운 위치:', position);
            if (position) {
                setSuggestionsPosition(position);
            } else {
                // 위치 계산에 실패한 경우 기본 위치 사용
                var textarea = inputRef.current;
                var rect = textarea.getBoundingClientRect();
                setSuggestionsPosition({
                    top: rect.bottom,
                    left: rect.left
                });
            }
        } else {
            // 토큰이 없으면 자동완성 드롭다운 숨김
            setCurrentToken(null);
            setSuggestions([]);
            setSuggestionsPosition(null);
        }
    };
    // 토큰 감지 시 처리
    var handleTokenDetection = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(token) {
            var query, results;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        query = token.token.slice(1);
                        // 쿼리 상태 업데이트
                        if (token.type === 'mention') {
                            setUserQuery(query);
                        } else if (token.type === 'hashtag') {
                            setHashtagQuery(query);
                        }
                        return [
                            4,
                            getSuggestions(token, usersQuery, hashtagsQuery, setIsSearching)
                        ];
                    case 1:
                        results = _state.sent();
                        setSuggestions(results);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTokenDetection(token) {
            return _ref.apply(this, arguments);
        };
    }();
    // 토큰 선택 처리
    var handleSelectSuggestion = function(suggestion) {
        // Escape 키로 닫기 요청이 들어온 경우 (suggestion === null)
        if (!suggestion) {
            setCurrentToken(null);
            setSuggestions([]);
            setSuggestionsPosition(null);
            return;
        }
        if (!currentToken || !inputRef.current) return;
        console.log('토큰 선택:', suggestion, '현재 토큰:', currentToken);
        // 텍스트에 선택한 항목 삽입
        var _insertTokenIntoText = insertTokenIntoText(text, currentToken, suggestion.value), newText = _insertTokenIntoText.newText, newPosition = _insertTokenIntoText.newPosition;
        setText(newText);
        // 프로젝트 타입인 경우 프리뷰 추가
        if (currentToken.type === 'project' && suggestion.type === 'project') {
            try {
                // API에서 프로젝트 정보 가져오기 (여기서는 모의 데이터 사용)
                var previewProject = {
                    id: suggestion.id,
                    title: suggestion.value,
                    description: suggestion.description || '프로젝트 설명',
                    category: 'web',
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                    author: {
                        id: 'user-1',
                        name: '작성자',
                        username: 'user1',
                        profileImage: ''
                    },
                    tags: [
                        '태그1',
                        '태그2'
                    ],
                    views: 0,
                    likes: 0,
                    comments: 0,
                    thumbnail: '',
                    content: '',
                    status: 'active',
                    collaborators: [],
                    stars: [],
                    reposts: []
                };
                setProjectPreviews(function(prev) {
                    return _to_consumable_array(prev).concat([
                        previewProject
                    ]);
                });
            } catch (error) {
                console.error('프로젝트 프리뷰 생성 실패:', error);
            }
        }
        // 자동완성 드롭다운 닫기
        setCurrentToken(null);
        setSuggestions([]);
        setSuggestionsPosition(null);
        // 커서 위치 설정 및 포커스
        setTimeout(function() {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.selectionStart = newPosition;
                inputRef.current.selectionEnd = newPosition;
            }
        }, 0);
    };
    return {
        currentToken: currentToken,
        suggestions: suggestions,
        isSearching: isSearching || queryIsLoading,
        suggestionsPosition: suggestionsPosition,
        detectTokenAndShowSuggestions: detectTokenAndShowSuggestions,
        handleTextChange: handleTextChange,
        handleSelectSuggestion: handleSelectSuggestion
    };
}
